import ProfileForm from "./ProfileForm";


const ProfileMain = () => {
  return (
    <div id="react-contact" className="react-contact-page pt---100">
      <div className="container">
        <div className="row justify-content-center pb---96">
          <div className="col-lg-6">
            <ProfileForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileMain;
